var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "moon-star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0013 18.3332L31.8687 16.0679C31.382 15.0945 31.1386 14.6077 30.8135 14.186C30.525 13.8117 30.1894 13.4762 29.8152 13.1877C29.3934 12.8626 28.9067 12.6192 27.9332 12.1325L25.668 10.9998L27.9332 9.86722C28.9067 9.38049 29.3934 9.13712 29.8152 8.812C30.1894 8.52351 30.525 8.18798 30.8135 7.81371C31.1386 7.39193 31.382 6.9052 31.8687 5.93174L33.0013 3.6665L34.1339 5.93174C34.6206 6.9052 34.864 7.39193 35.1891 7.81371C35.4776 8.18798 35.8132 8.52351 36.1874 8.812C36.6092 9.13712 37.0959 9.38049 38.0694 9.86722L40.3346 10.9998L38.0694 12.1325C37.0959 12.6192 36.6092 12.8626 36.1874 13.1877C35.8132 13.4762 35.4776 13.8117 35.1891 14.186C34.864 14.6077 34.6206 15.0945 34.1339 16.0679L33.0013 18.3332Z",
    fill: "#E5BEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5013 24.5469C36.0978 28.763 31.5613 31.6056 26.3609 31.6056C18.6483 31.6056 12.396 25.3533 12.396 17.6408C12.396 12.44 15.239 7.90323 19.4557 5.49984C10.5976 6.33972 3.66797 13.7992 3.66797 22.8772C3.66797 32.5178 11.4833 40.3332 21.124 40.3332C30.2016 40.3332 37.6608 33.4043 38.5013 24.5469Z",
    fill: "#AFBBE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0013 18.3332L31.8687 16.0679C31.382 15.0945 31.1386 14.6077 30.8135 14.186C30.525 13.8117 30.1894 13.4762 29.8152 13.1877C29.3934 12.8626 28.9067 12.6192 27.9332 12.1325L25.668 10.9998L27.9332 9.86722C28.9067 9.38049 29.3934 9.13712 29.8152 8.812C30.1894 8.52351 30.525 8.18798 30.8135 7.81371C31.1386 7.39193 31.382 6.9052 31.8687 5.93174L33.0013 3.6665L34.1339 5.93174C34.6206 6.9052 34.864 7.39193 35.1891 7.81371C35.4776 8.18798 35.8132 8.52351 36.1874 8.812C36.6092 9.13712 37.0959 9.38049 38.0694 9.86722L40.3346 10.9998L38.0694 12.1325C37.0959 12.6192 36.6092 12.8626 36.1874 13.1877C35.8132 13.4762 35.4776 13.8117 35.1891 14.186C34.864 14.6077 34.6206 15.0945 34.1339 16.0679L33.0013 18.3332Z",
    stroke: "#3F2C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5013 24.5469C36.0978 28.763 31.5613 31.6056 26.3609 31.6056C18.6483 31.6056 12.396 25.3533 12.396 17.6408C12.396 12.44 15.239 7.90323 19.4557 5.49984C10.5976 6.33972 3.66797 13.7992 3.66797 22.8772C3.66797 32.5178 11.4833 40.3332 21.124 40.3332C30.2016 40.3332 37.6608 33.4043 38.5013 24.5469Z",
    stroke: "#3F2C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonStar);
export default __webpack_public_path__ + "static/media/moon-star.6a42900d85c0d8ae4532e77e0f6571e5.svg";
export { ForwardRef as ReactComponent };